import DataTable from 'Components/DataTable';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { fss } from 'neuro-schemas';
import { arrayOfAll, isNumber } from 'neuro-utils';
import * as React from 'react';
import { useMyServiceContext } from '../..';
import colors from '../../../../../config/theme/colors';
import { formatPartialDate } from 'Utility/date';
import browserLanguage from 'Utility/browserLanguage';
import { useAppSelector } from 'Store/index';

const fssFields = arrayOfAll.keys<Omit<IFSS, 'date'>>()([
  'motivation',
  'exercise',
  'tendency',
  'physicalActivity',
  'problems',
  'sustainedPhysicalActivity',
  'duties',
  'disability',
  'life',
]);

export const Fss = (): React.JSX.Element => {
  const locale = useAppSelector(s => s.settings.userSettings.uiLanguage) ?? browserLanguage;
  const { editing, setEditingData, viewing } = useMyServiceContext<'fss'>();
  const fssData: IFSS = editing?.data ?? viewing?.data ?? {};
  const fssLocales = fss.getLocalizations(locale);

  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    if (!field) return;
    const value = Object.values(values)[0];
    setEditingData?.({
      ...fssData,
      [field]: value,
    } as any);
  };

  const totalScore = fss.calculateScore(fssData);

  return (
    <>
      <BlockWrapper title={viewing ? formatPartialDate(fssData.date) : undefined}>
        {!viewing && (
          <FormRow title={'general.date'} headerWidth={5.3}>
            <InputHandler
              name="date"
              type="PartialDate"
              dateDefault="now"
              formData={{
                document: { date: fssData.date },
                onChange: onChangeSurveyForm,
              }}
              editing={!!editing}
            />
          </FormRow>
        )}
        <div style={{ color: colors.tertiaryText }}>
          <p>{fssLocales.info}</p>
          <p>{`${fssLocales.agreeInfo}, ${fssLocales.disagreeInfo}`}</p>
        </div>
        <div style={{ width: '60%', marginBottom: '2rem', marginTop: '2rem' }}>
          <DataTable
            headers={['', '', '']}
            data={{
              rowData: fssFields.map(f => {
                const rowSet = [
                  fssLocales[`${f}.title`],
                  fssLocales[`${f}.description`],
                  <InputHandler
                    key={f}
                    name={f}
                    type="Radio"
                    editing={!!editing}
                    formData={{
                      document: { [f]: fssData[f] },
                      onChange: onChangeSurveyForm,
                    }}
                    options={[1, 2, 3, 4, 5, 6, 7]}
                  />,
                ];
                return rowSet;
              }),
              rowStyle: viewing ? undefined : fssFields.map(() => ({ rowAlign: 'top' })),
            }}
          />
        </div>
        <FormRow title="myService.mgravis.fssScore" headerStyle={{ fontWeight: 600 }} headerWidth={7}>
          <div style={{ color: colors.tertiaryText, fontWeight: 600 }}>
            <span>{isNumber(totalScore) ? totalScore : '-'}</span>
          </div>
        </FormRow>
      </BlockWrapper>
      <div style={{ color: colors.tertiaryText, fontStyle: 'italic' }}>
        <p>{fssLocales.reference}</p>
      </div>
    </>
  );
};
